function isValidDate(date) {
  return date && Object.prototype.toString.call(date) === "[object Date]" && !isNaN(date);
}


/**
 * Function to sort alphabetically an array of objects by some specific key.
 *
 * @param {String} property Key of the object to sort.
 */
export function sortBy(property, ascending=false) {
  return function (a,b) {
      const _a = a[property];
      const _b = b[property];
      var result;
      if (_a === null && _b === null) {
        result = 0;
      } else if (_a === null && _b != null) {
        result = -1;
      } else if (_a != null && _b === null) {
        result = 1;
      } else {
        if (isValidDate(_a) && isValidDate(_b)) {
          result = _b - _a;
        } else {
          result = _a.localeCompare(_b);
        }
      }
      if (ascending){
        return -1 * result;
      }
      return result;
  }
}
